import React from "react";
import { Text, View } from "native-base";
import { History } from "lucide-react-native";
import { Platform } from "react-native";
import { webFont } from "../../../Universal/API/API";
import PressableWrapp from "../../../Universal/Buttons/PressableReact/PressableWrapp";
import { webCursorPointer } from "./helpers";

type CollapsedButtonProps = {
  scaleAll: number;
  top: number;
  right: number;
  onPress: () => void;
};

const CollapsedButton: React.FC<CollapsedButtonProps> = ({ scaleAll, top, right, onPress }) => {
  return (
    <View
      style={{
        position: Platform.OS === "web" ? ("fixed" as any) : "absolute",
        top,
        right,
        zIndex: 40,
      }}
    >
      <PressableWrapp
        onPress={onPress}
        style={[
          {
            minHeight: 52 * scaleAll,
            borderRadius: 20 * scaleAll,
            backgroundColor: "#111111",
            paddingHorizontal: 16 * scaleAll,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            shadowColor: "#000",
            shadowOpacity: 0.18,
            shadowRadius: 24,
            shadowOffset: { width: 0, height: 14 },
            elevation: 10,
          },
          webCursorPointer,
        ]}
      >
        <History size={18 * scaleAll} color="#FFFFFF" />
        <Text
          selectable={false}
          style={{
            fontFamily: webFont("Inter"),
            fontSize: 14 * scaleAll,
            color: "#FFFFFF",
            fontWeight: "700",
            marginLeft: 8 * scaleAll,
          }}
        >
          История заказов
        </Text>
      </PressableWrapp>
    </View>
  );
};

export default React.memo(CollapsedButton);
